var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.gallery()}}},[_vm._v("View Galleries")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.refresh()}}},[_vm._v("Refresh Galleries")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.info.data))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535c7fd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminGallery.vue
// module id = null
// module chunks = 